var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "30px",
    viewBox: "0 0 27 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45968758,26 L17.4596876,26 L17.4596876,30 L9.45968758,30 L9.45968758,26 Z M13.4596876,0 C9.19745512,0 6.1158839,1.95534618 4.63108109,5.48670224 L4.53211166,5.7286718 C3.73050179,7.74525144 3.502188,9.7855003 3.46558623,13.3123013 L3.46268758,13.592 L0.986090358,16.6888723 C0.347763384,17.486781 0,18.4781783 0,19.5 C0,21.9852814 2.01471863,24 4.5,24 L22.4193752,24 C23.4411969,24 24.4325941,23.6522366 25.2305029,23.0139096 L25.4024421,22.8693056 C27.1885364,21.2905598 27.438781,18.5707425 25.9332848,16.6888723 L23.4556876,13.592 L23.453795,13.3159993 C23.4157231,9.64442825 23.1703015,7.58441002 22.2882941,5.48670224 C20.8034913,1.95534618 17.72192,0 13.4596876,0 Z M13.4596876,4 C19.1827645,4 19.4469065,8.69991943 19.4590977,14.1968955 L19.4596876,15 L22.8098096,19.1876525 C22.9823143,19.4032834 22.9473536,19.7179296 22.7317227,19.8904344 C22.6430662,19.9613596 22.5329109,20 22.4193752,20 L4.5,20 C4.22385763,20 4,19.7761424 4,19.5 C4,19.3864643 4.03864038,19.276309 4.1095656,19.1876525 L7.45968758,15 L7.46440674,13.404988 C7.51081184,8.25609249 8.01353373,4 13.4596876,4 Z",
    id: "Combined-Shape",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7e40fe26bb2f63466af1dcf1ac5bc25c.svg";
export { ForwardRef as ReactComponent };